export default __webpack_public_path__ + "4f126038ba632d7b478008f1a4d3b9ce.jpg";